// eslint-disable-next-line import/no-cycle
import ajax from '../../ajax';

export default {
  namespaced: true,

  state: {
  },

  mutations: {
  },

  actions: {
    async get({ commit }, params) {
      return ajax.get('/api/v1/auth/prq_registrations/new', { params })
        .then((response) => {
          return response;
        })
        .catch((errors) => { return Promise.reject(errors.response.data) });
    },

    async post({ commit }, params) {
      return ajax.post('/api/v1/auth/prq_registrations', params)
        .then((response) => {
          commit('users/set', response.data.data.attributes, { root: true });
          commit('auth/setCSRF', response.data.meta.csrf, { root: true });
        })
        .catch((errors) => { return Promise.reject(errors.response.data) });
    },
  },
};
